import { useEntityAttributesContext } from "../entity-attributes/context";
import { ALL } from "./constants";
import { useTranslations } from "use-intl";

export function useGroupsOptions() {
  const { data } = useEntityAttributesContext();
  const t = useTranslations("DynamicAttributeGroupSelector");

  const groups = data?.getDynamicAttributeGroupMetaInfo.groups.map((group) => ({
    value: group.id,
    label: group.name.value,
    key: group.id,
  }));

  groups?.push({
    key: "all",
    label: t("All"),
    value: ALL,
  });

  return groups;
}

export function getGroupIdBySelectedGroup(selectedGroup: string) {
  if (selectedGroup === ALL) {
    return undefined;
  }

  return selectedGroup;
}
